import React from 'react';
import {Link} from "react-router-dom";
import {getErrorsFromResponse, getTypeFromListItem, sectorMonthsToPieData} from "../../utils/helpers";
import BarChart from "./BarChart";
import {addSavedRoute, removeSavedRoute} from "../../actions";
import {connect} from "react-redux";
import {withTranslation} from 'react-i18next';
import {compose} from 'redux';
import {format} from "date-fns";
import {useAuth} from "../../context/auth-context";
import {useUser} from "../../hooks/useUser";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Alert, Box, Button} from "@mui/material";
import Constants from "../../config/constants";
import FabRoute from "../FabRoute";
import WarningComponent from "../WarningComponent";
import TooltipComponent from "../TooltipComponent";
import SwitchSecteur from "./SwitchSecteur";
import {MuiButton} from "../MuiButton";
import useSEO from "../../hooks/useSEO";
import {getUrl, PWAUrls, PWAUrlsParams} from "../../config/urls";
import OpenCloseWysiwigContent from "../OpenCloseWysiwigContent";
import GlobalFlashMessages from "../User/FlashMessages/FlashMessages";

const SecteurComponent = ({t, i18n, secteur, saveRoute, unsaveRoute, error, status, unlock, isOnline}) => {
    const auth = useAuth();
    const {data, status: statusStoredRoutes} = useUser(auth.user?.email, i18n.language);
    const storedRoutes = Array.isArray(data?.user?.customerRoutes) ? data.user.customerRoutes : [];

    let barChartData = [];
    if (secteur?.barChart) {
        barChartData = secteur.barChart;
    }

    let pieChartMonthData = [];

    if (Array.isArray(secteur?.months) && secteur.months.length) {
        pieChartMonthData = sectorMonthsToPieData(secteur.months, i18n.language);
    }

    const isSaved = Array.isArray(storedRoutes) ? storedRoutes.find((el) => el.route.id === secteur.id) : false;

    let lastUpdateUi = null ;
    if (typeof secteur.lastUpdateUi !== 'undefined' && secteur.lastUpdateUi) {
        lastUpdateUi =  format(new Date(secteur.lastUpdateUi.slice(0, 10)), 'dd/MM/yyyy');
    }

    const seoTitleParams = {label: secteur.label, region: secteur.region.label, cliff: secteur.cliffLabel };
    const seoDescriptionParams = {...seoTitleParams, routeCount: secteur.enabledRouteCount}
    if (secteur.barChart.length === 1) {
        seoDescriptionParams.grades = t('seo.grade', {grade: secteur.barChart[0].grade});
    } else if (secteur.barChart.length > 1) {
        seoDescriptionParams.grades = t('seo.grades', {minGrade: secteur.barChart[0].grade, maxGrade: secteur.barChart[secteur.barChart.length -1].grade});
    }

    const canonical = getUrl(PWAUrls.SECTOR_ROUTE, {lng: i18n.language, routeType: getTypeFromListItem(secteur,  i18n.language), slugRegion: secteur.region.slug, slugGroupRoute: secteur.slugGroupRoute, slug: secteur.slug});
    useSEO({title: t("seo.title.sector_route", seoTitleParams), description: t("seo.description.sector_route", seoDescriptionParams)}, canonical);

    return (
        <div className="row">
            <div className="col-12 secteurContent">
                <div className="secteur-content-infos">
                    <Box display="flex" p={0} pb={0} alignItems="center">
                        <Box flexGrow={1} pr={1}>
                            <h2 className="mb-3 mt-3">
                                {secteur.label+ " "}
                                {lastUpdateUi && <TooltipComponent title={t("SecteurListComponent.popover.last_update", {lastUpdateUi: lastUpdateUi})} color="tertiary">
                                    <FontAwesomeIcon icon={['fa', 'fire']} size="sm" />
                                </TooltipComponent>}
                            </h2>
                        </Box>
                        <Box pr={1}>
                            <SwitchSecteur
                                route={secteur}/>
                        </Box>
                    </Box>

                    <OpenCloseWysiwigContent description={secteur.description} descriptionShort={secteur.descriptionShort} />

                    <hr/>

                    <div className="row align-items-center justify-content-center">
                        {barChartData.length > 0 && <div className="col-12 col-lg-6 order-lg-5 mb-3 text-center">
                            <BarChart data={barChartData}
                                      width={400}
                                      height={175}
                                      title={t('SecteurComponent.barchart.title')}
                                      id={'BarChart'}
                            />
                        </div>}

                        <div className="col-12 col-lg-12 order-lg-1">
                            {/*<div className="row align-items-center">*/}
                            {/*    <div className="col-12">*/}
                                    {secteur.warning && <div className="float-right mb-2">
                                        <WarningComponent title={secteur.warning} />
                                    </div>}
                                    <dl className="dl-inline m-0" style={{paddingTop: secteur.warning ? '34px' : 'inherit'}}>
                                        {secteur.orientation && <React.Fragment>
                                            <dt>{t('SecteurComponent.properties.orientation')} </dt>
                                            <dd>{secteur.orientation}</dd>
                                        </React.Fragment>}
                                        {secteur.enabledRouteCount > 0 && <React.Fragment>
                                            <dt>{t('SecteurComponent.properties.route_count')} </dt>
                                            <dd>{secteur.enabledRouteCount}</dd>
                                        </React.Fragment>}
                                        {secteur.ropeLength && <React.Fragment>
                                            <dt>{t('SecteurComponent.properties.rope_length')} </dt>
                                            <dd>{secteur.ropeLength}m</dd>
                                        </React.Fragment>}
                                        {secteur.climbingStyle && <React.Fragment>
                                            <dt>{t('SecteurComponent.properties.climbing_style')} </dt>
                                            <dd>{secteur.climbingStyle}</dd>
                                        </React.Fragment>}
                                        {secteur.approachTimeLabel && <React.Fragment>
                                            <dt>{t('SecteurComponent.properties.approach_time')} </dt>
                                            <dd>{secteur.approachTimeLabel}</dd>
                                        </React.Fragment>}
                                        {secteur.family && <React.Fragment>
                                            <dt>{t('SecteurComponent.properties.family')} </dt>
                                            <dd>{secteur.family ? t('App.common.yes') : t('App.common.no')} </dd>
                                        </React.Fragment>}
                                        {(secteur.equipmentShort || secteur.equipment)  && <React.Fragment>
                                            <dt>{t('SecteurComponent.properties.equipment')}</dt>
                                            <dd>
                                                <OpenCloseWysiwigContent description={secteur.equipment}
                                                                         descriptionShort={secteur.equipmentShort}
                                                                         openCta={'+'}
                                                                         closeCta={'-'}
                                                />
                                            </dd>
                                        </React.Fragment>}
                                    </dl>

                            {/*    </div>*/}
                            {/*</div>*/}
                        </div>

                        {pieChartMonthData.length > 0 && <div className="col-12 col-lg-6 mb-3 text-center order-lg-3">
                            <h3>{t('SecteurComponent.piechart.title')}</h3>
                            <div className={"container"}>
                                <div className="row" style={{
                                    borderBottom: '1px solid',
                                    borderRight: '1px solid'
                                }}>
                                    {pieChartMonthData.map((object, i) => {
                                        return (
                                            <div key={i} className="col-2 col-lg-2 cal-propice" style={{
                                                backgroundColor: object.backgroundColor,
                                                color: object.color,
                                                borderLeft: '1px solid',
                                                borderTop: '1px solid',
                                                borderColor: '#000',
                                                paddingLeft: '5px',
                                                paddingRight: '5px',
                                                fontSize: '0.8rem',
                                            }}>
                                                {object.nameShort}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>}

                        {/*{!unlock && <div className="col-12 order-lg-3">*/}
                        {/*    <AlertUnlockComponent guidebooks={secteur.guidebookInfos}*/}
                        {/*                          routeType={Constants.TypeTopo.FALAISE}*/}
                        {/*                          product={secteur.product}*/}
                        {/*    />*/}
                        {/*</div>}*/}

                        {/*{unlock && <div className="col-12"><GlobalFlashMessages regionIds={secteur?.regionDescendantIds}/></div>}*/}

                        <div className="col-12 pt-3 order-lg-5">
                            <div className="row justify-content-lg-center align-items-center mb-3">
                                {error && <Alert
                                    severity='error'
                                    style={{marginTop: "15px", marginBottom: "15px"}}>
                                    {getErrorsFromResponse(error.response).map((e, i) => {
                                        return (<span key={i}>{e}<br/></span>);
                                    })}
                                </Alert>}
                                <div className="col-12 col-md-6 mb-lg-2 mt-2 mt-lg-0">
                                    {error &&
                                    <Alert severity='error' style={{marginTop: "15px", marginBottom: "15px"}}>
                                        {error.response.data.error.pop().message}
                                    </Alert>
                                    }
                                    {isSaved && <MuiButton
                                                        onClick={unsaveRoute}
                                                        disabled={!unlock || status === "pending" || !isOnline}
                                                        variant="contained" color="secondary" fullWidth>
                                        {status === "pending" && <FontAwesomeIcon icon={["fas", "spinner"]} spin className="mr-2" />}
                                        {status !== "pending" && <FontAwesomeIcon icon={["fas", "save"]} className="mr-2"/>}
                                        {t('SecteurComponent.button.saved')}
                                    </MuiButton>}
                                    {!isSaved &&  <MuiButton
                                                        onClick={saveRoute}
                                                        disabled={!isOnline || !unlock || status === "pending" || statusStoredRoutes !== "success" || storedRoutes.length >= import.meta.env.VITE_MAX_STORAGE}
                                                        variant="contained" color="primary" fullWidth>
                                        {t('SecteurComponent.button.save')}
                                    </MuiButton>}

                                    <Button to={window.location.pathname + "/" + PWAUrlsParams.details[i18n.language]}
                                            component={Link}
                                            disabled={!unlock}
                                            className="mt-1"
                                            variant="contained" color="primary" fullWidth>{t('SecteurComponent.button.voies')}</Button>
                                </div>
                                <div className="col-12 col-md-6 mb-lg-2 mt-2 mt-lg-0">
                                    <MuiButton onClick={() => window.open("mailto:"+import.meta.env.VITE_CONTACT_MAIL+"?subject=" + encodeURIComponent(t('SecteurComponent.report.subject') + secteur.fullLabel),"_self")} color="quaternary" className="m-0" variant="contained" fullWidth>
                                        {t('SecteurComponent.button.report')}
                                    </MuiButton>
                                </div>
                                <div className="col-12 col-lg-auto text-center text-lg-left mt-2 mt-lg-0">
                                    <p className="m-0 text-tertiary small-help">{t('SecteurComponent.button.report_help')}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <FabRoute
                unlock={unlock}
                route={secteur}
                product={secteur.product}
                type={Constants.TypeTopo.FALAISE}
            />
        </div>
    );
}

const mapDispatchToProps = dispatch => {
    return {
        addSavedRoute: (route) => {
            dispatch(addSavedRoute(route))
        },
        removeSavedRoute: (route) => {
            dispatch(removeSavedRoute(route))
        },
    }
}
const mapStateToProps = (state, ownProps) => {
    return {
        savedRoutes: state.navbar.savedRoute,
        isOnline: state.common.isOnline,
    }
}
export default
    compose(
        withTranslation(),
        connect(
            mapStateToProps,
            mapDispatchToProps
        ))(SecteurComponent);